/** PC/Xbox hang 卡死类型筛选。值进 URL `pcHangSplit`，请求体转 stuckExpName SCG，禁止当 exceptionTypeList。
 * 平台：PC=10、Xbox=12。Linux=20 不加。禁止用 isPcOrLinux。 */

export const HANG_SPLIT_PID_PC = 10;
export const HANG_SPLIT_PID_XBOX = 12;
export const HANG_SPLIT_PID_LINUX = 20;

/** 卡死类型下拉只给 PC 与 Xbox。 */
export function isHangSplitPlatform(pid) {
  const n = Number(pid);
  return n === HANG_SPLIT_PID_PC || n === HANG_SPLIT_PID_XBOX;
}

export const PC_HANG_SPLIT_ALL = '';
export const PC_HANG_SPLIT_PRESENT = 'PresentHang';
export const PC_HANG_SPLIT_UNKNOWN = 'Unknown';
export const PC_HANG_SPLIT_GT = 'GTHang';

export const PC_HANG_SPLIT_OPTIONS = [
  { label: 'PresentHang', value: PC_HANG_SPLIT_PRESENT, shortLabel: 'PresentHang' },
  { label: 'Unknown', value: PC_HANG_SPLIT_UNKNOWN, shortLabel: 'Unknown' },
  { label: 'GTHang', value: PC_HANG_SPLIT_GT, shortLabel: 'GTHang' },
];

/** 只认 URL/redux 的 pcHangSplit。空串 = 所有类型。 */
export function resolvePcHangSplitKey({ pcHangSplit } = {}) {
  return pcHangSplit || PC_HANG_SPLIT_ALL;
}

/** queryIssueList 的 stuckExpName 条件。字符串与 IssueCrashFilterExUtil 对齐。 */
export function buildPcHangSplitSearchConditionGroup(splitKey) {
  if (splitKey === PC_HANG_SPLIT_PRESENT) {
    return {
      conditions: [{
        field: 'stuckExpName',
        queryType: 'TERM',
        term: 'PresentHang',
      }],
    };
  }
  if (splitKey === PC_HANG_SPLIT_UNKNOWN) {
    return {
      operator: 'OR',
      conditions: [
        {
          field: 'stuckExpName',
          queryType: 'TERM',
          term: 'UnknownThread',
        },
        {
          field: 'stuckExpName',
          queryType: 'NONEMPTY',
          not: true,
        },
      ],
    };
  }
  if (splitKey === PC_HANG_SPLIT_GT) {
    return {
      conditions: [
        {
          field: 'stuckExpName',
          queryType: 'NONEMPTY',
        },
        {
          field: 'stuckExpName',
          queryType: 'TERM',
          term: 'PresentHang',
          not: true,
        },
        {
          field: 'stuckExpName',
          queryType: 'TERM',
          term: 'UnknownThread',
          not: true,
        },
      ],
    };
  }
  return undefined;
}
